import { pipe } from 'ramda';
import { setAction, setReceivedLabel } from '@creditas-lab/analytics-events';
import { DispatchEvent, dispatchFrontendDashboardEvent } from './commons';

const dispatchBlogEvent: DispatchEvent = pipe(setAction('blog'), dispatchFrontendDashboardEvent);

const dispatchBlogArticleEvent: DispatchEvent = pipe(setReceivedLabel, dispatchBlogEvent);

export { dispatchBlogArticleEvent };
